import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList, ViewChild,
  ViewChildren
} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {Swiper, SwiperOptions} from "swiper";
import {GalleryItemComponent} from "../gallery/gallery-item/gallery-item.component";
import {GalleryItemData} from "../gallery-preview/gallery-item-data";

@Component({
  selector: 'brt-gallery-slider',
  templateUrl: './gallery-slider.component.html',
  styleUrls: ['./gallery-slider.component.scss']
})
export class GallerySliderComponent implements Overlayable, AfterViewInit {

  @ViewChild("mainEl") mainEl!: ElementRef<HTMLDialogElement>;
  @Output("onClosed") onClosed = new EventEmitter<boolean>();
  @Input("items") set setItems(val: GalleryItemData[]) {
    this.items = val;
    this.totalSlides = this.items.length;
  }

  @ViewChildren(GalleryItemComponent) ytComponent!: QueryList<GalleryItemComponent>;

  @Input("offset") offset = 0;

  slider!: Swiper;
  items: GalleryItemData[] = [];
  sliderOptions: SwiperOptions = {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 16,
    threshold: 5,
    keyboard: {
      enabled: true
    },
    on: {
      slideChangeTransitionEnd: (swiper) => {
        // this.currentSlide = swiper.activeIndex;
        // console.log("slideChangeTransitionEnd");
      },
      transitionEnd: (swiper) => {
        this.currentSlide = swiper.activeIndex + 1;
        this.cdRef.detectChanges();
      }
    }
  }
  isLoaded = false;

  totalSlides = 1;
  currentSlide = 1;

  constructor(private cdRef: ChangeDetectorRef) {
  }

  ngAfterViewInit() {

    if(this.mainEl.nativeElement) {
      this.mainEl.nativeElement.showModal();

      const mainElHtml = this.mainEl.nativeElement;

      const videos = mainElHtml.querySelectorAll(".gallery-item__video iframe");

      videos.forEach((el) => {
        const height = el.clientHeight;

        const iframeAttrWidth = parseInt(el.getAttribute("width") ?? "0");
        const iframeAttrHeight = parseInt(el.getAttribute("height") ?? "0");
        const width = height * iframeAttrWidth / iframeAttrHeight;
        const elHtml = el as HTMLElement;
        elHtml.style.width = width + "px";
      })
      // console.log(videos);

      if(this.slider) {
        this.slider.update();
      }
    }

    setTimeout(() => {
      this.isLoaded = true;
    }, 1000);

  }

  saveInstance($event: [swiper: Swiper]) {
    this.slider = $event[0];
    this.slider.slideTo(this.offset);
  }

  onItemLoaded() {
    // console.log("Item loaded, updating swiper");
    this.slider.update();
    this.slider.updateProgress();
    this.slider.updateSize();
    this.slider.slideTo(this.offset, 0);

    setTimeout(() => {
      this.isLoaded = true;
    }, 600);
  }

  prevSlide() {
    this.slider.slidePrev();
  }

  nextSlide() {
    this.slider.slideNext();
  }

  goToSlide(idx: number) {
    this.slider.slideTo(idx);
  }
}
